"use client";

// ==============================================================================
// ClientLayout — Layout client-side con autenticación TRS Auth
// ==============================================================================
// Envuelve la aplicación con AuthProvider y muestra el botón de logout
// en el header cuando el usuario está autenticado.
// ==============================================================================

import AuthProvider, { useAuth } from "@/components/AuthProvider";
import { ReactNode } from "react";

export default function ClientLayout({ children }: { children: ReactNode }) {
    return (
        <AuthProvider>
            {children}
        </AuthProvider>
    );
}
